import api from "../../../api/api";
import { FilterObj } from "./useCutsheetSelector";

async function getCutsheetImage(
  doorType: string,
  typeOfData: string,
  filter: FilterObj
) {
  try {
    const res = await api.post("/api/getCutsheetImage", {
      doorType,
      typeOfData,
      filter,
    });
    return res.data;
  } catch (err) {
    console.error(err);
    return "";
  }
}

export default getCutsheetImage;
